import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidTreesIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M17 5c-.9 0-1.7.2-2.5.7-1.3-3.1-4.8-4.5-7.8-3.2C4.5 3.4 3 5.6 3 8v4c0 2.9 2.1 5.4 5 5.9V21c0 .6.4 1 1 1s1-.4 1-1v-3.1c1-.2 2-.6 2.8-1.3.7 1.2 1.9 2 3.2 2.2V21c0 .6.4 1 1 1s1-.4 1-1v-2.1c2.3-.5 4-2.5 4-4.9v-4c0-2.8-2.2-5-5-5Zm3 9c0 1.3-.8 2.4-2 2.8V13c0-.6-.4-1-1-1s-1 .4-1 1v3.8c-1-.3-1.7-1.2-1.9-2.2 0-.2-.1-.4-.1-.7v-4c0-.7.3-1.4.7-1.9 1.1-1.3 2.9-1.4 4.2-.4.7.7 1.1 1.5 1.1 2.4v4Z"/>
  </SvgIcon>
}

export default SolidTreesIcon
